import { comics, genreList } from "@/mocks/comics";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import GenreNav from "@/pages/home/components/GenreNav";
import SiteIntro from "@/pages/home/components/SiteIntro";
import SectionHeader from "@/components/feature/SectionHeader";
import ComicCard from "@/components/feature/ComicCard";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function Home() {
  useDocumentTitle(
    "老司机漫画-热门漫画连载与精彩章节推荐",
    "老司机漫画为您提供丰富多样的热门漫画内容，涵盖各种题材和风格，支持在线浏览和最新章节更新，满足漫画爱好者的阅读需求。",
  );

  const featured = [...comics].sort((a, b) => b.rating - a.rating).slice(0, 5);
  const latest = [...comics]
    .sort((a, b) => (a.updateTime < b.updateTime ? 1 : -1))
    .slice(0, 8);
  const popular = [...comics].sort((a, b) => b.favorites - a.favorites).slice(0, 10);

  return (
    <main className="pb-16">
      <HeroCarousel comics={featured} />

      <section className="w-full px-4 md:px-6 mt-10 md:mt-14">
        <SectionHeader
          title="按题材找漫画"
          subtitle="热门题材快捷入口，点击直达分类"
          icon="ri-apps-2-line"
        />
        <GenreNav genres={genreList} />
      </section>

      <section className="w-full px-4 md:px-6 mt-10 md:mt-14">
        <SectionHeader
          title="最新更新"
          subtitle="刚刚更新的连载章节"
          morePath="/category"
          icon="ri-time-line"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {latest.map((comic) => (
            <ComicCard key={comic.id} comic={comic} variant="horizontal" />
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-6 mt-10 md:mt-14">
        <SectionHeader
          title="人气推荐"
          subtitle="读者收藏与评分最高的作品"
          morePath="/category?sort=popular"
          icon="ri-fire-line"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
          {popular.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </section>

      <div className="w-full px-4 md:px-6 mt-10 md:mt-14">
        <SiteIntro />
      </div>
    </main>
  );
}